"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = require("./Button");

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const AddFilesButton = _styledComponents.default.div.withConfig({
  displayName: "FileUpload__AddFilesButton",
  componentId: "sc-1uv4oqw-0"
})(["", " display:inline-block;margin:0;"], _Button.ButtonStyle);

const AddIcon = (0, _styledComponents.default)(_SVGIcon.default).withConfig({
  displayName: "FileUpload__AddIcon",
  componentId: "sc-1uv4oqw-1"
})(["height:32px;width:48px;padding:12px;", ";&:hover{background:#f7f8f2;}svg path{fill:", ";}"], p => p.theme.transition, p => p.theme.colors.main);

const loadFile = async file => new Promise(resolve => {
  const reader = new FileReader();

  reader.onloadend = e => {
    resolve(e.target.result);
  };

  reader.readAsDataURL(file);
});

const handleFileSelect = onSelect => async e => {
  const {
    target
  } = e;
  const {
    files
  } = target;
  const newItems = [];

  for (const [idx, file] of Array.from(files).entries()) {
    const newItem = {
      tmpID: Date.now() + idx,
      name: file.name
    };

    if (file.size <= MAX_FILE_SIZE) {
      newItem.data = await loadFile(file);
    } else {
      newItem.err = 'MAX_FILE_SIZE';
    }

    newItems.push(newItem);
  }

  target.value = null;
  onSelect(newItems);
};

const FileUpload = ({
  className,
  buttonText,
  icon,
  title,
  onSelect
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: className
}, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", {
  type: "file",
  multiple: true,
  onChange: handleFileSelect(onSelect)
}), buttonText && /*#__PURE__*/_react.default.createElement(AddFilesButton, null, buttonText), icon && /*#__PURE__*/_react.default.createElement(AddIcon, {
  name: icon,
  title: title
})));

var _default = (0, _styledComponents.default)(FileUpload).withConfig({
  displayName: "FileUpload",
  componentId: "sc-1uv4oqw-2"
})(["input{width:0.1px;height:0.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1;}"]);

exports.default = _default;